<template>
    <div v-cloak>
        <div v-if="state == 'loading'" class="text-info">
            <span class="fa-stack mr-2">
                <i class="spinner-grow spinner-grow-sm"></i>
            </span>
            Loading amenities ...
        </div>
        
        <div v-if="state == 'error-loading'" class="alert alert-danger">
            Could not load amenities
        </div>
        
        <template v-if="state != 'init' && state != 'loading'">
            <table class="table" v-if="activeAmenities.length">
                <thead v-show="false">
                    <th class="border-top-0">Amenity</th>
                    <th class="border-top-0">Cost</th>
                    <th class="border-top-0">Additional Info</th>
                    <th class="border-top-0"></th>
                </thead>
                <amenity 
                    v-for="amenity in activeAmenities" 
                    :amenity="amenity" 
                    :key="amenity.id" 
                    v-on:remove="removeAmenity(amenity)"
                ></amenity>
            </table>
            
            <template v-if="availableAmenities.length">
                <VueSelect 
                    v-model="selectedAmenity"
                    :options="availableAmenities" 
                    style="width: 400px; margin-bottom: 4px" 
                    @input="addAmenity"
                    placeholder="Add an amenity ..."
                    :clear-search-on-select="true"
                    :close-on-blur="true"
                ></VueSelect>
            </template>
            
            <div v-if="state == 'error-saving'" class="alert alert-danger">
                Could not save amenities. Please try again.
            </div>
            
            <button v-if="!value" class="btn btn-primary mt-1" @click.prevent="saveAmenities">
                Save
                <template v-if="state == 'saving'"><i class="fa fa-spinner fa-spin fa-fw ml-1"></i></template>
            </button>
        </template>
    </div>
</template>

<script>
import axios from 'axios'
import VueSelect from 'vue-select'
import Amenity from './Amenity'

import 'vue-select/dist/vue-select.css';

export default {
    components: {
        VueSelect,
        Amenity,
    },
    props: {
        value: {
            type: Array,
            default() {
                return null;
            },
        },
    },
    data() {
        return {
            state: 'init',
            selectedAmenity: null,
            amenities: [],
            allAmenities: [],
            updatingFromProp: false,
        };
    },
    computed: {
        activeAmenities() {
            return [...this.amenities].sort(this.amenitySorter);
        },
        availableAmenities() {
            return [...this.allAmenities].sort(this.amenitySorter).filter(amenity => !this.amenityIsActive(amenity)).map(amenity => {
                return { label: amenity.title, value: amenity };
            });
        },
    },
    watch: {
        value() {
            this.updatingFromProp = true;
            this.amenities = this.value;
            this.updatingFromProp = false;
        },
        amenities: {
            handler() {
                if (this.updatingFromProp) return;
                this.$emit('input', this.amenities);
            },
            deep: true,
        }
    },
    methods: {
        amenityIsActive(amenity) {
            return this.amenities.some(fAmenity => fAmenity.id == amenity.id)
        },
        addAmenity(amenity) {
            this.amenities.push(amenity.value)
            this.selectedAmenity = null
        },
        removeAmenity(amenity) {
            let index = this.amenities.findIndex(foundAmenity => foundAmenity.id == amenity.id);
            this.amenities.splice(index, 1)
        },
        amenitySorter(a, b) {
            const titleA = a.title.toUpperCase();
            const titleB = b.title.toUpperCase();

            let comparison = 0;
            if (titleA > titleB) {
                comparison = 1;
            } else if (titleA < titleB) {
                comparison = -1;
            }
            return comparison;
        },
        fetchAmenities() {
            this.state = 'loading';
            axios({
                url: process.env.VUE_APP_API_BASE_URL + '/amenities',
            }).then(response => {
                this.allAmenities = response.data.data; 
                this.state = 'idle';
            }).catch(error => {
                console.log({ error: error })
                this.state = 'idle';
            })
        },
    },
    created() {
        this.fetchAmenities();
    },
    mounted() {
        this.amenities = this.value;
    }
}
</script>

<style scoped>

</style>
